import { IsOptional } from "class-validator";

import { IShowScent } from "./show-scent.interface";

export class ShowScentDto implements IShowScent {
  @IsOptional()
  scent?: string;

  @IsOptional()
  location?: string;
}
